<!--
 * @Description: 导航栏
-->
<template>
  <div class="navbar">
    <Hamburger
      v-if="!isMobileDevice"
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggle-click="toggleSideBar"
    />
    <BreadCrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    />
    <div class="right-menu">
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span class="user-avatar-name">{{ userName }}</span>
          <img
            :src="UserIcon"
            class="user-avatar"
            alt=""
          >
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <router-link :to="{name: 'UserInfo'}">
              <el-dropdown-item v-if="!isMobileDevice">
                {{ t('navbar.userInfo') }}
              </el-dropdown-item>
            </router-link>
            <router-link :to="{name: 'ResetPassword'}">
              <el-dropdown-item v-if="!isMobileDevice">
                {{ t('navbar.resetPassword') }}
              </el-dropdown-item>
            </router-link>
            <router-link :to="{name: 'SetMFA'}">
              <el-dropdown-item v-if="!isMobileDevice">
                {{ t('navbar.setMFA') }}
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item
              divided
              @click="logout"
            >
              <span style="display:block;">
                {{ t('navbar.logOut') }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import BreadCrumb from '@/components/bread-crumb/Index.vue'
import Hamburger from '@/components/hamburger/Index.vue'
import UserIcon from '@/assets/images/home/user.png'

import { computed, reactive, toRefs } from 'vue'
import { useStore } from '@/store'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { useI18n } from 'vue-i18n'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { useRoute, useRouter } from 'vue-router'
import resize from '@/layout/resize'

export default {
  components: {
    BreadCrumb,
    Hamburger
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    const device = computed(() => {
      return store.state.app.device.toString()
    })
    const userName = computed(() => {
      return store.state.user.info.userName
    })
    const { isMobile } = resize()
    /*
    const avatar = computed(() => {
      return store.state.user.avatar || 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
    })
    */
    const state = reactive({
      isMobileDevice: isMobile(),
      toggleSideBar: () => {
        store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false)
      },
      logout: () => {
        useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT)
        router.push(`/login?redirect=${route.fullPath}`).catch(err => {
          console.warn(err)
        })
      }
    })
    return {
      sidebar,
      device,
      UserIcon,
      userName,
      ...toRefs(state),
      t
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    padding: 0 15px;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        margin-top: 5px;
        margin-right: 16px;
        margin-left: 16px;
        position: relative;
        display: flex;
        align-items: center;  // 垂直居中
        gap: 8px;  // 可选，设置头像和文字之间的间距

        .user-avatar-name {
          cursor: pointer;
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
